// CTSK-509 — /notes: the signed-in user's own standalone notes (no target).
// Visible to the author only. With enableNotes off the page shows a short
// "turned off" message (the sidebar entry is hidden too).

import { EmptyState } from '../components/EmptyState.js';
import { NotesSection } from '../components/notes/NotesSection.js';
import { NotesToolbar } from '../components/notes/NotesToolbar.js';
import { useNotePrefs, type NotesOrdering } from '../components/notes/useNotes.js';
import { useNotesAccess } from '../hooks/useNotesAccess.js';

export function StandaloneNotes({ focusId = null, onNavigate }: { focusId?: string | null; onNavigate?: (path: string) => void }) {
  const access = useNotesAccess();
  const { prefs, ready, save } = useNotePrefs(access.ready && access.enabled);
  if (!access.ready) return null;
  const ordering: NotesOrdering =
    prefs.orderMode === 'manual' ? { mode: 'manual' } : { mode: 'sorted', sortKey: prefs.sortKey, sortDir: prefs.sortDir };
  if (!access.enabled) {
    return (
      <EmptyState
        title="Notes are turned off"
        body="An administrator can turn notes back on under Settings → Documents."
      />
    );
  }
  return (
    <div className="notes-page">
      <h2 style={{ marginTop: 0 }}>Notes</h2>
      <p style={{ color: 'var(--text-muted)', marginTop: 0 }}>
        Your own sticky notes. Only you can see them. Notes on a document or work item live on that page.
      </p>
      <NotesToolbar prefs={prefs} onChange={save} />
      {/* Hold the list until the saved view is known, so it never loads twice. */}
      {ready && (
      <NotesSection
        params={{ mine: true, ordering }}
        gridType={prefs.gridType}
        focusId={focusId}
        onReordered={() => save({ orderMode: 'manual' })}
        access={access}
        paged
        emptyText="No notes yet. Add one to get started."
        onNavigate={onNavigate}
      />
      )}
    </div>
  );
}
